import { __assign } from "tslib";
import { ONE_KILO_BYTE, validateAndBuildConfiguration, display, isExperimentalFeatureEnabled, removeDuplicates, ConsoleApiName, objectHasValue, } from '@datadog/browser-core';
import { buildEnv } from '../boot/buildEnv';
/**
 * arbitrary value, byte precision not needed
 */
export var DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT = 32 * ONE_KILO_BYTE;
export function validateAndBuildLogsConfiguration(initConfiguration) {
    var baseConfiguration = validateAndBuildConfiguration(initConfiguration, buildEnv);
    if (!baseConfiguration) {
        return;
    }
    var forwardConsoleLogs = [];
    if (isExperimentalFeatureEnabled('forward-logs') && initConfiguration.forwardConsoleLogs !== undefined) {
        var allowedConsoleApis = Object.keys(ConsoleApiName);
        if (!(initConfiguration.forwardConsoleLogs === 'all' ||
            (Array.isArray(initConfiguration.forwardConsoleLogs) &&
                initConfiguration.forwardConsoleLogs.every(function (api) { return objectHasValue(ConsoleApiName, api); })))) {
            display.error("Forward Console Logs should be \"all\" or an array with allowed values \"" + allowedConsoleApis.join('", "') + "\"");
            return;
        }
        forwardConsoleLogs =
            initConfiguration.forwardConsoleLogs === 'all' ? allowedConsoleApis : initConfiguration.forwardConsoleLogs;
    }
    if (initConfiguration.forwardErrorsToLogs) {
        forwardConsoleLogs.push(ConsoleApiName.error);
    }
    return __assign(__assign({}, baseConfiguration), { forwardErrorsToLogs: !!initConfiguration.forwardErrorsToLogs, forwardConsoleLogs: removeDuplicates(forwardConsoleLogs), requestErrorResponseLengthLimit: DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT });
}
//# sourceMappingURL=configuration.js.map